import { ButtonIcon, TextLeftIcon, TextMiddleIcon, TextRightIcon, Tooltip } from 'canoe';
import React from 'react';

import { useResponsiveCss, useSelection } from 'craft/hooks';
import { CommonNodeProperties } from 'craft/types';
import { createToggle } from 'craft/utils';

export const TextAlignmentButtons = () => {
  const { selection } = useSelection();
  const { responsiveCss: css, setResponsiveCss: setCss } = useResponsiveCss(
    selection.all,
    CommonNodeProperties.Multiple,
  );

  const { textAlign } = css;
  const toggleValues = createToggle(css, setCss);

  if (selection.isEmpty || selection.hasRootNode) {
    return null;
  }

  return (
    <>
      <Tooltip placement="top" offset="xxs" content="Align Left">
        <ButtonIcon
          size="small"
          icon={TextLeftIcon}
          active={textAlign === 'left'}
          onClick={() => toggleValues({ textAlign: 'left' })}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip placement="top" offset="xxs" content="Align Center">
        <ButtonIcon
          size="small"
          icon={TextMiddleIcon}
          active={textAlign === 'center'}
          onClick={() => toggleValues({ textAlign: 'center' })}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip placement="top" offset="xxs" content="Align Right">
        <ButtonIcon
          size="small"
          icon={TextRightIcon}
          active={textAlign === 'right'}
          onClick={() => toggleValues({ textAlign: 'right' })}
          radius="small"
          color="white"
        />
      </Tooltip>
    </>
  );
};
